import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
    IOption,
    IOrderDetails,
    sides,
} from '../../../../models/product-detail';
import { ISelectedOptionIds } from '../../../../models/product-detail';
import { findIcon, APIDs, RECEIVER_GAIN_NAME } from '../../../common/constants';
import { useIntl } from 'react-intl';
import { getGainId } from '../../../../hooks/gain-translate-hook';

interface ISingleOptionTypeProps {
    options: IOption[];
    orderDetails: IOrderDetails;
    onChange: (rightSelectedIds: number[], leftSelectedIds: number[]) => void;
    optionName: string;
    selectedSide: sides;
    multiSelect: boolean;
    selectedIds: ISelectedOptionIds;
}

const SingleOptionType = ({
    options,
    orderDetails,
    onChange,
    optionName,
    selectedSide,
    multiSelect,
    selectedIds,
}: ISingleOptionTypeProps) => {
    const intl = useIntl();
    const earsides =
        !selectedSide && orderDetails.cros
            ? [sides.left]
            : selectedSide === sides.binaural
            ? [sides.right, sides.left]
            : selectedSide === sides.right
            ? [sides.right]
            : [sides.left];

    const updateSelectedIds = (event: React.ChangeEvent<HTMLInputElement>) => {
        const right = selectedIds.rightSelectedIds.concat([]);
        const left = selectedIds.leftSelectedIds.concat([]);
        if (multiSelect) {
            switch (event.target.name.split('-')[0]) {
                case sides.right:
                    if (event.target.checked) {
                        right.push(parseInt(event.target.value));
                    } else {
                        if (right.indexOf(parseInt(event.target.value)) >= 0)
                            right.splice(
                                right.indexOf(parseInt(event.target.value)),
                                1
                            );
                    }
                    break;
                case sides.left:
                    if (event.target.checked) {
                        left.push(parseInt(event.target.value));
                    } else {
                        if (left.indexOf(parseInt(event.target.value)) >= 0)
                            left.splice(
                                left.indexOf(parseInt(event.target.value)),
                                1
                            );
                    }
                    break;
            }
        } else {
            options.forEach((x) => {
                switch (event.target.name.split('-')[0]) {
                    case sides.right:
                        if (x.id === parseInt(event.target.value)) {
                            right.push(parseInt(event.target.value));
                            ///CROS logic
                            if (
                                APIDs.includes(parseInt(event.target.value)) &&
                                orderDetails.side === 'B'
                            ) {
                                if (left.indexOf(x.id) >= 0) {
                                    left.splice(left.indexOf(x.id), 1);
                                    if ([510, 511].includes(x.id))
                                        left.push(x.id === 510 ? 511 : 510);
                                    if ([595, 596].includes(x.id))
                                        left.push(x.id === 595 ? 596 : 595);
                                    if ([1308, 1309].includes(x.id))
                                        left.push(x.id === 1308 ? 1309 : 1308);
                                } else {
                                    if ([510, 511].includes(x.id))
                                        left.push(x.id === 510 ? 511 : 510);
                                    if ([595, 596].includes(x.id))
                                        left.push(x.id === 595 ? 596 : 595);
                                    if ([1308, 1309].includes(x.id))
                                        left.push(x.id === 1308 ? 1309 : 1308);
                                }
                            }
                        } else {
                            if (right.indexOf(x.id) >= 0)
                                right.splice(right.indexOf(x.id), 1);
                        }
                        break;
                    case sides.left:
                        if (x.id === parseInt(event.target.value)) {
                            left.push(parseInt(event.target.value));
                            ///CROS logic
                            if (
                                APIDs.includes(parseInt(event.target.value)) &&
                                orderDetails.side === 'B'
                            ) {
                                if (right.indexOf(x.id) >= 0) {
                                    right.splice(right.indexOf(x.id), 1);
                                    if ([510, 511].includes(x.id))
                                        right.push(x.id === 510 ? 511 : 510);
                                    if ([595, 596].includes(x.id))
                                        right.push(x.id === 595 ? 596 : 595);
                                    if ([1308, 1309].includes(x.id))
                                        right.push(x.id === 1308 ? 1309 : 1308);
                                } else {
                                    if ([510, 511].includes(x.id))
                                        right.push(x.id === 510 ? 511 : 510);
                                    if ([595, 596].includes(x.id))
                                        right.push(x.id === 595 ? 596 : 595);
                                    if ([1308, 1309].includes(x.id))
                                        right.push(x.id === 1308 ? 1309 : 1308);
                                }
                            }
                        } else {
                            if (left.indexOf(x.id) >= 0)
                                left.splice(left.indexOf(x.id), 1);
                        }
                        break;
                }
            });
        }

        onChange(right, left);
    };
    return (
        <>
            {selectedIds &&
                earsides &&
                options.map((option) => {
                    return (
                        <div key={`${option.id}${option.name}`}>
                            {earsides.map((side) => {
                                if (
                                    side === sides.left
                                        ? option.isAvailableLeft &&
                                          !option.hidden
                                        : option.isAvailableRight &&
                                          !option.hidden
                                ) {
                                    return (
                                        <p className="dual-radio" key={side}>
                                            {multiSelect ? (
                                                <input
                                                    type="checkbox"
                                                    name={
                                                        side + '-' + option.name
                                                    }
                                                    id={
                                                        side + '-' + option.name
                                                    }
                                                    value={option.id}
                                                    defaultChecked={
                                                        side === sides.left
                                                            ? selectedIds.leftSelectedIds.includes(
                                                                  option.id
                                                              )
                                                            : selectedIds.rightSelectedIds.includes(
                                                                  option.id
                                                              )
                                                    }
                                                    onChange={updateSelectedIds}
                                                />
                                            ) : (
                                                <input
                                                    type="radio"
                                                    name={
                                                        side + '-' + optionName
                                                    }
                                                    id={
                                                        side + '-' + option.name
                                                    }
                                                    value={option.id}
                                                    checked={
                                                        side === sides.left
                                                            ? selectedIds.leftSelectedIds.includes(
                                                                  option.id
                                                              )
                                                            : selectedIds.rightSelectedIds.includes(
                                                                  option.id
                                                              )
                                                    }
                                                    onChange={updateSelectedIds}
                                                />
                                            )}
                                            <label
                                                className={`dual-radio-label-${
                                                    side === sides.left
                                                        ? 'blue'
                                                        : 'red'
                                                }`}
                                                htmlFor={
                                                    side + '-' + option.name
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={findIcon(
                                                        'fal',
                                                        'ear'
                                                    )}
                                                    style={{
                                                        color:
                                                            side === sides.left
                                                                ? 'blue'
                                                                : 'red',
                                                    }}
                                                />
                                            </label>
                                        </p>
                                    );
                                }
                                return undefined;
                            })}
                            {((selectedSide !== sides.right &&
                                option.isAvailableLeft) ||
                                (selectedSide !== sides.left &&
                                    option.isAvailableRight)) && (
                                <label>
                                    {optionName === RECEIVER_GAIN_NAME
                                        ? intl.formatMessage({
                                              id: getGainId(option.english),
                                              defaultMessage: option.name,
                                          })
                                        : option.name}
                                </label>
                            )}
                        </div>
                    );
                })}
        </>
    );
};

export default SingleOptionType;
